module.exports = __webpack_public_path__ + "static/img/daily-task.103c37b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/Pages/DailyTask/img/task/daily-task.png
// module id = 501
// module chunks = 0